import MuiListItem, { ListItemProps as MuiListItemProps } from '@mui/material/ListItem';
import * as React from 'react';

export interface ListItemProps extends MuiListItemProps {}

export const ListItem = (props: ListItemProps) => {
  return <MuiListItem {...props} />;
};
